<template>
    <div class="ag-theme-alpine" style="height: 200px; margin-bottom: 20px;">

      <ag-grid-vue
        ref="gridRef"
        :rowData="localContacts"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        style="width: 100%; height: 150px;"
        :rowSelection="{ type: 'single' }"
        @grid-ready="onGridReady"
      ></ag-grid-vue>

    </div>
    <el-button v-if="isSupplierManager"  type="primary" @click="addContract">연락처 추가</el-button>
    <el-button  v-if="isSupplierManager"  type="danger" @click="deleteContract">연락처 삭제</el-button>
    <el-button  v-if="isSupplierManager" type="success" @click="saveContract">저장</el-button>
  </template>

  <script setup>
  import { ref ,onMounted,watch} from "vue";
  import axiosInstance from "@/api/axios";
  import { useUserStore } from "@/stores/user";
  import { ElMessage } from "element-plus";

  const props = defineProps({
    supplierId: {
      type: [Number, null], // Null 허용
      required: true,
    },
 
  });

  const userStore = useUserStore();
  const isSupplierManager = userStore.isSupplierManager;
  
  const emit = defineEmits(["update:modelValue",  "close"]);

  const localContacts= ref([  ]);
  const supplierId =  ref(props.supplierId );

  const contactTypes = [
    { value: "PHONE", label: "전화번호" },
    { value: "FAX", label: "팩스" },
    { value: "EMAIL", label: "이메일" },
  ];

  const columnDefs = [
    {
      field: "contact_type",
      headerName: "연락처 유형",
      editable: true,
      cellEditor: "agSelectCellEditor", // 드롭다운 에디터
      cellEditorParams: {
        values: contactTypes.map((type) => type.value), // 선택 가능한 값
      },
      valueFormatter: (params) => {
        // 값의 표시를 라벨로 변환
        const type = contactTypes.find((item) => item.value === params.value);
        return type ? type.label : params.value;
      },
      valueSetter: (params) => {
        // 드롭다운에서 선택된 값을 설정
        params.data.contact_type = params.newValue;
        return true;
      },
    },
    { field: "contact_value", headerName: "연락처 정보", editable: true },
];
  
  const defaultColDef = {
    flex: 1,
    sortable: true,
    resizable: true,
    editable:true,
  };

  const gridRef = ref(null);
  const gridApi = ref(null);

  const onGridReady = (params) => {
    gridApi.value = params.api; // gridApi 초기화
    console.log("Grid API Initialized:", gridApi.value);
  };

// ✅ supplierId가 변경될 때 자동으로 연락처 목록 불러오기
watch(() => props.supplierId, (newSupplierId) => {
  console.log("ContactGrid - supplierId 변경 감지:", newSupplierId);
  supplierId.value = newSupplierId;

  if (supplierId.value) {
    fetchContacts(); // 새로운 supplierId로 연락처 불러오기
  }
});

    // 서버에서 계좌 리스트 조회
const fetchContacts = async () => {
  if (!supplierId.value) {
    console.warn("fetchContacts: supplierId가 설정되지 않음.");
    return;
  }


  try {
    const response = await axiosInstance.get(`/suppliers/${supplierId.value}/contacts/`);
    localContacts.value = response.data.results; // 서버에서 받아온 데이터를 로컬 상태에 저장
    console.log("서버에서 연락처 데이터 조회 성공:", response.data);
  } catch (error) {
    console.error("서버에서 연락처 데이터를 가져오는 중 오류 발생:", error);    
    ElMessage.error("연락처 데이터를 불러오는 중 오류가 발생했습니다.");

  }
};


  // 새로운 연락처 추가
  const addContract = () => {

    if (!supplierId.value) {
      ElMessage.warning("매입처를 먼저 저장하세요.");
      return;
    }

    

    gridApi.value.applyTransaction({
      add: [{  id: null, bank_name: "", account_number: "", account_holder: "" }],
    });

    syncLocalAccounts();  
  };
  

  const deleteContract = async  () => {
    const selectedNodes = gridApi.value.getSelectedNodes();

    if (selectedNodes.length > 0) {
      const selectedData = selectedNodes.map((node) => node.data);

       // 서버와 동기화
       for (const contract of selectedData) {
      if (contract.id) {
          try {
            await axiosInstance.delete(`/suppliers/${supplierId.value}/contacts/${contract.id}/`);
            console.log("서버에서 삭제 완료:", contract.id);
          } catch (error) {
            console.error("서버 삭제 중 오류 발생:", error);
            ElMessage.error(`연락처 ID ${contract.id} 삭제 중 문제가 발생했습니다.`);

            return;
          }
        }
      }


      gridApi.value.applyTransaction({
          remove: selectedNodes.map((row) => row.data),
      });
      
      // Vue 데이터와 동기화
      syncLocalAccounts();
   } else {
    ElMessage.warning("삭제할 행을 선택하세요.");
  } 
}


  
const syncLocalAccounts = () => {
    // ag-grid 데이터 -> Vue 데이터 동기화
    const updatedContacts = [];
    gridApi.value.forEachNode((node) => {
      updatedContacts.push(node.data);
    });

    localContacts.value = updatedContacts; // Vue 데이터 업데이트
    console.log("Vue와 ag-grid 데이터 동기화 완료:", localContacts.value);
  };
  
  const saveContract = async () => {
     if (!supplierId.value) {
      console.error("매입처 ID가 없습니다. 연락처 저장을 수행할 수 없습니다.");
      ElMessage.error("매입처 정보가 없습니다. 먼저 매입처를 저장하세요.");
      return;
    }


        try {
        console.log("연락처 시작:", localContacts.value);
        console.log("연락처 저장 시작 supplierId:", supplierId.value);
          for (const contact of localContacts.value) {
            console.log("연락처 저장 시작 account.id:", contact.id);

            if (contact.id) {
              // 기존 데이터 수정
              await axiosInstance.put(`/suppliers/${supplierId.value}/contacts/${contact.id}/`, contact);
              console.log("연락처 정보 수정 완료:", contact);
            } else {
              // 새 데이터 생성
              const response = await axiosInstance.post(`/suppliers/${supplierId.value}/contacts/`, contact);
              contact.id = response.data.id; // 새로 생성된 ID 저장
              console.log("연락처 정보 생성 완료:", contact.id );
            }
          }
        console.log("모든 연락처 정보 저장 완료");
        ElMessage.success("연락처 정보가 성공적으로 저장되었습니다.");

      } catch (error) {
        console.error("연락처 정보 저장 중 오류 발생:", error);
        ElMessage.error("연락처 정보를 저장하는 중 오류가 발생했습니다.");

      }

      //fetchContacts();
      emit("close"); // 부모에게 닫기 이벤트 전달

  };


onMounted(() => {
    console.log("ContactGrid mounted");
   console.log(props.supplierId)

    if (supplierId.value ){
   
      fetchContacts(); // 컴포넌트가 로드될 때 계좌 리스트를 서버에서 조회
    }
  });
  </script>
  